/**
 * dashboardApi.js
 * ---------------
 * API client for Employee Self-Service Dashboard.
 * Connects directly to FastAPI backend /self-service/dashboard/ adhering to Rule 90.
 */
import api from '../../../../api/client';

export const dashboardApi = {
  getSummary: async () => {
    const response = await api.get('/self-service/dashboard/summary');
    return response.data;
  },

  getBirthdays: async () => {
    const response = await api.get('/self-service/dashboard/birthdays');
    return response.data;
  },

  getAnniversaries: async () => {
    const response = await api.get('/self-service/dashboard/anniversaries');
    return response.data;
  },

  getAttendanceMetrics: async () => {
    const response = await api.get('/self-service/dashboard/attendance-metrics');
    return response.data;
  },
};

